import React, {useEffect, useState} from 'react';
import {Typography} from "@mui/material";
import payoutBatchElementApi from "src/api/payment/payoutBatchElementApi";
import PayoutBatchElementList from "src/components/account/PayoutBatchElementList";
import {Link} from "react-router-dom";

const PayoutsPage = () => {

  return (
    <>
      <Typography variant="h2" mb={2}>Uitbetalingen</Typography>
      <Typography variant="body1" mb={2}>Hier zie je informatie over de betaling die we al naar jou hebben gedaan of die nog in behandeling zijn. Ga naar <Link to={"/"}>dashboard</Link> om een nieuwe uitbetaling aan te vragen.</Typography>
      <PayoutBatchElementList />
    </>
  );
}

export default PayoutsPage;

PayoutsPage.propTypes = {};

PayoutsPage.defaultProps = {};
